import React from "react";
import { Formik, Form, Field } from "formik";
import moment from "moment";
import ModalComponent from "../../../components/Modal";
import TextInput from "../../../components/TextInput";
import TextArea from "../../../components/TextArea";
import MuiDatePicker from "../../../components/MuiDatePicker";

const RequirementForm = ({ show, onClose, onSave, initialValues, isEditMode = false }) => {
  return (
    <ModalComponent
      show={show}
      onClose={onClose}
      title={isEditMode ? "Edit Requirement" : "Add Requirement"}
    >
      <Formik
        initialValues={initialValues}
        enableReinitialize
        onSubmit={async (values, { resetForm, setSubmitting }) => {
          try {
            await onSave(values);
            resetForm();
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {({ errors, touched, handleChange, values, isSubmitting, setFieldValue }) => (
          <Form className="max-h-[85vh] overflow-y-auto">
            <div className="mt-4" />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div>
                <TextInput
                  value={values?.clientName || ""}
                  name="clientName"
                  placeholder="Client Name"
                  handleChange={handleChange}
                  type="text"
                  classes="w-full"
                  legend="Client Name"
                />
              </div>
              {errors.clientName && touched.clientName && (
                  <div className="text-red-500 text-sm">{errors.clientName}</div>
                )}
              <div>
                <TextInput
                  value={values?.location || ""}
                  name="location"
                  placeholder="Location"
                  handleChange={handleChange}
                  type="text"
                  classes="w-full"
                  legend="Location *"
                />
                {errors.location && touched.location && (
                  <div className="text-red-500 text-sm">{errors.location}</div>
                )}
              </div>
            

              <div>
                <TextInput
                  value={values?.position || ""}
                  name="position"
                  placeholder="Position"
                  handleChange={handleChange}
                  type="text"
                  classes="w-full"
                  legend="Position *"
                />
                {errors.position && touched.position && (
                  <div className="text-red-500 text-sm">{errors.position}</div>
                )}
              </div>
              <div>
                <TextInput
                  value={values?.rate || ""}
                  name="rate"
                  placeholder="Rate"
                  handleChange={handleChange}
                  type="text"
                  classes="w-full"
                  legend="Rate"
                />
              </div>
              {errors.rate && touched.rate && (
                <div className="text-red-500 text-sm">{errors.rate}</div>
              )}
             
              <div>
                <TextInput
                  value={values?.source || ""}
                  name="source"
                  placeholder="Source"
                  handleChange={handleChange}
                  type="text"
                  classes="w-full"
                  legend="Source"
                />
              </div>
              {errors.source && touched.source && (
                <div className="text-red-500 text-sm">{errors.source}</div>
              )}
              <div>
                
                <MuiDatePicker
                  label="Requirement Date"
                  value={values?.requirementDate ? moment(values.requirementDate, ["MM/DD/YYYY", "YYYY-MM-DD", "MM-DD-YYYY"], true) : null}
                  onChange={(date) => {
                    if (date) {
                      setFieldValue("requirementDate", date.format("MM/DD/YYYY"));
                    } else {
                      setFieldValue("requirementDate", "");
                    }
                  }}
                />
                {errors.requirementDate && touched.requirementDate && (
                  <div className="text-red-500 text-sm">{errors.requirementDate}</div>
                )}
              </div>
              <div>
                <div className="flex items-center space-x-4">
                  <label className="text-sm font-medium text-gray-700">Status *</label>
                  <div className="flex items-center space-x-6">
                    <label className="flex items-center space-x-2">
                      <Field
                        type="radio"
                        name="stsCd"
                        value="A"
                        checked={values.stsCd === "A"}
                        className="text-blue-600 focus:ring-blue-500"
                      />
                      <span className="text-sm text-gray-700">Active</span>
                    </label>
                    <label className="flex items-center space-x-2">
                      <Field
                        type="radio"
                        name="stsCd"
                        value="D"
                        checked={values.stsCd === "D"}
                        className="text-blue-600 focus:ring-blue-500"
                      />
                      <span className="text-sm text-gray-700">Deactive</span>
                    </label>
                  </div>
                </div>
                {errors.stsCd && touched.stsCd && (
                  <div className="text-red-500 text-sm mt-1">{errors.stsCd}</div>
                )}
              </div>
              <div>
                <MuiDatePicker
                  label="Expiry Date"
                  value={values?.expiryDate ? moment(values.expiryDate, ["MM/DD/YYYY", "YYYY-MM-DD", "MM-DD-YYYY"], true) : null}
                  onChange={(date) => {
                    if (date) {
                      setFieldValue("expiryDate", date.format("MM/DD/YYYY"));
                    } else {
                      setFieldValue("expiryDate", "");
                    }
                  }}
                />
                {errors.expiryDate && touched.expiryDate && (
                  <div className="text-red-500 text-sm">{errors.expiryDate}</div>
                )}
              </div>
              <div className="sm:col-span-2">
                <TextArea
                  value={values?.description || ""}
                  name="description"
                  placeholder="Description"
                  handleChange={handleChange}
                  classes="w-full"
                  legend="Description"
                  rows={4}
                />
                {errors.description && touched.description && (
                  <div className="text-red-500 text-sm">{errors.description}</div>
                )}
                <div className="text-xs text-gray-500 text-right">
                  {(values.description || "").length}/500 characters
                </div>
              </div>
            </div>
            <div className="mt-6 flex justify-end gap-3">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
              >
                {isSubmitting ? (isEditMode ? "Updating..." : "Adding...") : (isEditMode ? "Update Requirement" : "Add Requirement")}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </ModalComponent>
  );
};

export default RequirementForm;

